
import './index.less';

import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { AddIcon, DeleteIcon } from 'tdesign-icons-react';
import { Button, Collapse, Form } from 'tdesign-react';

import { IFormItemProps } from '@/components/form/interface';
import { ISchedule, ScheduleType } from '@/store/modules/__endpoints__/module';

import styles from './index.module.less';
import ItemComp from './Item';

const { FormItem } = Form;
const { Panel } = Collapse;

const random = () => `array_${dayjs().valueOf()}`;

interface IFormArrayProps {
  fieldsConfig: IFormItemProps[];
  form: any;
  repeatConfig?: {
    [key: string]: IFormItemProps[]
  };
}

const defaultValue: ISchedule[] = [{
  scheduleType: ScheduleType.SCHEDULE_TYPE_ONCE, startTime: {
    date: dayjs().format('YYYY-MM-DD'),
    moment: dayjs().format('HH:mm:ss'),
  },
  endTime: {
    date: dayjs().format('YYYY-MM-DD'),
    moment: dayjs().format('HH:mm:ss'),
  },
  fixedReplies: [],
}];

export const CustomSchedule: React.FC<
{
  value: ISchedule[];
  onChange: (value: ISchedule[]) => void;
  drag: boolean;
} & IFormArrayProps
> = (props) => {
  const {
    value = [],
    onChange,
  } = props;


  const [compValue, setCompValue] = useState<ISchedule[]>(value.length > 0 ? [] : defaultValue);

  const [keys, setKeys] = useState([defaultValue]?.map(() => random()));
  const [tempKeys, setTempKeys] = useState([defaultValue]?.map(() => random()));

  const [changeKeyIndex, setChangeKeyIndex] = useState<number>(-1);

  useEffect(() => {
    if (value.length > 0) {
      setCompValue([...value]);
      setArrayKeys();
    }
  }, [value]);

  useEffect(() => {
    setTempKeys(keys);
  }, [keys]);

  const setArrayKeys = () => {
    if (keys?.length !== value?.length) {
      const newKeys = [...value]?.map((_e, i) => {
        if (i === changeKeyIndex) {
          return `${random()}_${i}`;
        }
        return tempKeys?.[i] || `${random()}_${i}`;
      });
      setKeys(newKeys);
    }
  };

  const removeItem = (
    index: number,
    event: React.MouseEvent<HTMLElement, MouseEvent>,
  ) => {
    event.stopPropagation();
    const newArray = [...compValue];
    newArray.splice(index, 1);
    onChange([...newArray]);
    const tempKeys = [...keys];
    tempKeys.splice(index, 1);
    setKeys(tempKeys);
    if (newArray?.length === 0) {
      setCompValue([]);
    }
  };

  const addItem = (index: number, event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.stopPropagation();
    const newArray = [...compValue];
    newArray.splice(index + 1, 0, ...defaultValue);
    onChange(newArray);

    const tempKeys = [...keys];
    tempKeys.splice(index + 1, 0, random());
    setChangeKeyIndex(index + 1);
    setTempKeys(tempKeys);
  };

  return (
    <div className={styles.arrayWrap}>
      <Form labelAlign='top'>
        <Collapse expandIconPlacement='right'>
          {/* <ReactSortable
            disabled={true}
            handle={'.draggable'}
            list={compValue.map((x: any) => ({ ...x }))}
            onEnd={onEnd}
            setList={() => { }}
          > */}
          {compValue.map((item, index) => (
            <Panel header={<div className={styles.panel}>{`任务${index + 1}-${item.scheduleType === ScheduleType.SCHEDULE_TYPE_ONCE ? '单次' : '每日'}(${item.startTime.date || ''}${item.startTime.date ? '\xa0' : ''}${item.startTime.moment} - ${item.endTime.date || ''}${item.endTime.date ? '\xa0' : ''}${item.endTime.moment})`}</div>} key={`${keys?.[index]}`}>
              <div
                className="custom-form-group"
                style={{ alignItems: 'flex-start' }}
              >
                <div className={styles.group} style={{ flexGrow: '1' }}>
                  <ItemComp value={item} disabled={false} onChange={(val) => {
                    onChange([...value.slice(0, index), val, ...value.slice(index + 1)]);
                  }} />
                </div>
                <FormItem className={styles.options} style={{ marginTop: 22 }}>
                  <Button
                    className={styles.delete}
                    theme="default"
                    disabled={compValue.length === 1}
                    onClick={event => removeItem(index, event)}
                  ><DeleteIcon />删除</Button>
                  <Button
                    className={styles.add}
                    theme="default"
                    onClick={event => addItem(index, event)}
                  ><AddIcon />增加</Button>
                </FormItem>
              </div>
            </Panel>
          ))}
          {/* </ReactSortable> */}
        </Collapse>
      </Form>
    </div>
  );
};
